/** Choose the initial voice route without overriding an adult's saved preference. */
export type InitialSpeechMode = 'local' | 'device';

export interface SpeechPlatformCapabilities {
  readonly userAgent: string;
  readonly platform: string;
  readonly maxTouchPoints: number;
  readonly deviceSpeechAvailable: boolean;
}

export function selectInitialSpeechMode(
  storedMode: string | null,
  capabilities: SpeechPlatformCapabilities
): InitialSpeechMode {
  if (storedMode === 'local' || storedMode === 'device') {
    return storedMode;
  }

  // An unsupported browser must not default to a silent device route.
  if (!capabilities.deviceSpeechAvailable) {
    return 'local';
  }

  const mobileUserAgent = /Android|iPhone|iPad|iPod/i.test(capabilities.userAgent);
  // Modern iPadOS can present a desktop "Macintosh" user agent.
  const desktopModeIpad = capabilities.platform === 'MacIntel' && capabilities.maxTouchPoints > 1;

  return mobileUserAgent || desktopModeIpad ? 'device' : 'local';
}
